export default {"src":"/_next/static/media/inbound_noloop.88ba2251.gif","height":480,"width":1022,"blurWidth":0,"blurHeight":0};